import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { AppointmentModel } from 'src/app/core/models/appointment-model';
import moment from 'moment';
import { Router } from '@angular/router';
import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { SchedulerService } from '../scheduler.service';
import { Patient } from 'src/app/core/interfaces/patient';
import { FindTimeService } from 'src/app/core/services/find-time.service';
import { AppData } from 'src/app/app.data';
import { CustomerService } from 'src/app/core/services/customer.service';
import { ApiResponseCode, TreatmentStatus } from 'src/app/core/enums';
import { CustomerDetails } from 'src/app/core/models/customer-details';
import { Utils } from 'src/app/core/utils';
import { MatDialog } from '@angular/material/dialog';
import { AvailableBalanceDialogComponent } from '../../available-balance-dialog/available-balance-dialog.component';



@Component({
  selector: 'app-appointment-menu',
  templateUrl: './appointment-menu.component.html',
  styleUrls: ['./appointment-menu.component.scss']
})
export class AppointmentMenuComponent implements OnInit {

  @Input() appointment: AppointmentModel;
  @Output() delete: EventEmitter<any> = new EventEmitter();
  @Output() confirmed: EventEmitter<any> = new EventEmitter();
  @Output() paid: EventEmitter<any> = new EventEmitter();
  @Output() patientDetails: EventEmitter<any> = new EventEmitter();
  @Output() captureImage: EventEmitter<any> = new EventEmitter();
  @Output() uploadDocument: EventEmitter<any> = new EventEmitter();
  @Output() paymentRequest: EventEmitter<any> = new EventEmitter();
  @Output() sendOrFillForm: EventEmitter<any> = new EventEmitter();
 
 

  patient: Patient;
  settings: Settings;
  isAppointmentDetailsDisabled: boolean = false;
  canBeDeleted = true;
  canBeMoved = true;
  canBeMovedToWaitList = true;
  canEnterPatientDetails = true;
  canBeMarkedHasApproved=true;
  canCaptureImage = true;
  canUploadDocument = true;
  canMakePaymentRequestInPelecard=true;
  canMakePaymentRequestInBit=true;
  canSendOrFillForm=true;

  

  constructor(
    public translate: TranslateService,
    public authService: AuthenticateService,
    private router: Router,
    public appSettings: AppSettings,
    public schedulerService: SchedulerService,
    public customerService: CustomerService,
    private findtimeService: FindTimeService,
    private appData: AppData,
    private dialog: MatDialog) {
    this.settings = appSettings.settings;

  }

  ngOnInit() {

    
    // var hasPermission = this.authService.hasPermission(ClaimType.CanEditConfidentialPatients);
    let hasPermission = this.authService.claims.CanEditConfidentialPatients;
    this.isAppointmentDetailsDisabled = this.appointment.IsConfidential ? !hasPermission : false;
    this.canBeDeleted =  !this.appointment.Arrived &&
    !this.appointment.NoShow &&
    !(this.isDatePassed(this.appointment) || this.hasDoneTreatment(this.appointment));
    this.canBeMoved = !(this.isDatePassed(this.appointment) || this.appointment.Arrived || this.appointment.NoShow);
    this.canBeMovedToWaitList = !this.appointment.Arrived && !this.appointment.NoShow;
    this.canBeMarkedHasApproved = !this.appointment.Arrived;
    //this.patient = { ID: +this.appointment.EntityID, Name: this.appointment.Title };
    
    var entityData = this.appointment.getEntityData();
    this.patient = {
      ID: entityData.EntityID,
      Name: entityData.EntityName,
      Email: entityData.Email
    };
    this.canEnterPatientDetails = this.appointment.IsConfidential ? hasPermission : true; 
    this.canCaptureImage = true; // no limitation for now.
    this.canSendOrFillForm = true;
  }

  


  onDelete() {
    // Check if deletion is prevented by claim
    if (this.authService.claims.PreventAppointmentCancellation) {
      this.showNoPermissionDialog();
      return;
    }
    // appointment-menu component
    this.delete.emit(this.appointment);
  }

  onStandBy() {
    // Check if time change is prevented by claim
    if (this.authService.claims.PreventAppointmentTimeChange) {
      this.showNoPermissionToChangeTimeDialog();
      return;
    }

    this.appData.appointment = this.appointment;
    this.router.navigate(['/standby', { eventID: this.appointment.EventID} ]);
  }

  onConfirm() {
    this.appData.appointment = this.appointment;
    this.confirmed.emit(this.appointment);
  }
  onPaid() {
    
    this.appData.appointment = this.appointment;
    this.paid.emit(this.appointment);
  }
  onFutureVisits() {
    this.appData.appointment = this.appointment;
    this.appData.patient = this.patient;
    this.router.navigate(['/future-visits', this.appointment.EventID]);
  }

  onPatientDetails(){    
    // set patient in appData
    this.appData.patient = {ID: this.patient.ID, Name: this.patient.Name, Email: this.patient.Email };

    this.router.navigate(['/patient-details', this.patient.ID]);
  }

  onMove(){
    // Check if time change is prevented by claim
    if (this.authService.claims.PreventAppointmentTimeChange) {
      this.showNoPermissionToChangeTimeDialog();
      return;
    }

    // open findtime
    if(this.canBeMoved){
      this.appData.clearFindTimeData();
      this.appData.treatments = this.appointment.Treatments;
      this.customerService.getDetails(this.appointment.EntityID).subscribe(result => {
        if(result.Code === ApiResponseCode.Success){
          this.appData.customerDetails = new CustomerDetails(result.Data.customer);

          // get roomID of appointment by EventID
          this.schedulerService.getEventRoomInfo(this.appointment.EventID).subscribe(roomResult =>{
            if(roomResult.Code === ApiResponseCode.Success){
              this.appointment.SchedulerRoomID = roomResult.Data ? roomResult.Data.SchedulerID : 0;
              this.appData.appointment = this.appointment;
              this.router.navigate(['/find-time']);
            }
          });
        }
      });
    }
  }

  


  isDatePassed(appointment) { 
    return Utils.isDatePassed(appointment.Start);
  }

  hasDoneTreatment(appointment: AppointmentModel): boolean{
    if(appointment.Treatments && appointment.Treatments.length > 0){
      return appointment.Treatments.filter(x=> x.TreatmentStatusID === TreatmentStatus.Done).length > 0;
    }
    return false;
  }

  onCaptureImage(){      
    this.appData.appointment = this.appointment;
    this.appData.patient = this.patient;
    this.appData.captureImageData = { action: 'captureImage', appointment: this.appointment};
    this.captureImage.emit(this.appointment);
  }

  onCaptureProfileImage(){  
    this.appData.appointment = this.appointment;
    this.appData.patient = this.patient;
    this.appData.captureImageData = { action: 'captureProfileImage', appointment: this.appointment};
    this.captureImage.emit(this.appointment);
  }

  onUploadDocument(){    
    this.appData.appointment = this.appointment;
    this.appData.patient = this.patient;
    this.uploadDocument.emit(this.appointment);
  }


  onPaymentRequest(provider){           
    this.paymentRequest.emit({
      paymentRequest: provider,
      appointment: this.appointment,
      patient: this.patient
    });
  }

  onSendOrFillForm(){

    const branchID = this.appointment && this.appointment.BranchID || null;


    this.sendOrFillForm.emit({
        patient: this.patient,
        branchID:  branchID
    });
  }

  showNoPermissionDialog() {
    const msg = this.translate.instant('MSG.NO-PERMISSION-TO-CANCEL-APPOINTMENT');

    const dialogRef = this.dialog.open(AvailableBalanceDialogComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {
        message: msg,
        hideCancel: true
      }
    });
  }

  showNoPermissionToChangeTimeDialog() {
    const msg = this.translate.instant('MSG.NO-PERMISSION-TO-CHANGE-APPOINTMENT-TIME');

    const dialogRef = this.dialog.open(AvailableBalanceDialogComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {
        message: msg,
        hideCancel: true
      }
    });
  }

}
